import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";

export default function GoogleLoginButton() {
  return (
    <div className="w-full flex justify-center mb-8">
      <div className="w-full max-w-xs">
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            console.log(credentialResponse);
            toast.success("Google-kirjautuminen onnistui!");
          }}
          onError={() => {
            toast.error("Kirjautuminen Googlella epäonnistui.");
          }}
          useOneTap
          ux_mode="popup"
          width="100%"
          theme="filled_blue" // vaihtoehto "outline" tai "filled_black" jne.
          size="large" // tekee napista isomman
          shape="pill" // pyöreä nappi
          text="signin_with" // "Kirjaudu Google-tilillä"
        />
      </div>
    </div>
  );
}
